import { render, staticRenderFns } from "./CampoCustomRenderer.vue?vue&type=template&id=b3ef18f4&"
import script from "./CampoCustomRenderer.vue?vue&type=script&lang=js&"
export * from "./CampoCustomRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports